import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "list" ]

  updateList(event) {
    const files = Array.from(event.target.files || [])
    if (!this.hasListTarget) return

    this.listTarget.innerHTML = ""

    files.forEach(file => {
      const li = document.createElement("li")
      li.textContent = file.name
      this.listTarget.appendChild(li)
    })
  }
}
